import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

export type CloudModel = {
  provider: string;
  model: string;
  name: string;
  tags?: string[];
};

export type LocalModel = {
  model: string;
  name: string;
  size?: string;
  modified?: string;
};

export type CustomModel = {
  name: string;
  provider: string;
  model: string;
  endpoint?: string;
  hasApiKey: boolean;
};

export type OutputType = {
  cloudModels: CloudModel[];
  localModels: LocalModel[];
  customModels: CustomModel[];
  localEndpoint?: string;
  localApiKey?: string;
  localEnabled: boolean;
  error?: string;
  cloudError?: string;
};

export const getAiModels = async (init?: RequestInit): Promise<OutputType> => {
  // Client-side fetch with short connect timeout to avoid blocking the UI
  const controller = new AbortController();
  const timeout = (init && (init as any).timeoutMs) || 4000;
  const timer = setTimeout(() => controller.abort(), timeout);
  try {
    const result = await fetch(`/_api/ai/models`, {
      method: 'GET',
      credentials: 'include',
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...(init?.headers ?? {}),
      },
      signal: controller.signal,
    });
    clearTimeout(timer);

    if (!result.ok) {
      const text = await result.text();
      if (!text) {
        throw new Error(`Request failed with status ${result.status}`);
      }
      try {
        const errorObject = superjson.parse<{ error: string }>(text);
        throw new Error(errorObject.error);
      } catch (parseError) {
        throw new Error(`Request failed with status ${result.status}: ${text.substring(0, 100)}`);
      }
    }

    return superjson.parse<OutputType>(await result.text());
  } catch (err) {
    if ((err as any)?.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    throw err;
  }
};
